import * as React from "react";
import { useButton } from "@react-aria/button";
import { Icon } from "@nju/icons";
import { BlockText } from "../BlockText";

interface ArrowButtonProps {
  isExpanded: boolean;
  textExpanded?: string;
  textCollapsed?: string;
  onButtonPress(): void;
}
export function ArrowButton({
  isExpanded,
  textExpanded = "rozwiń szczegóły",
  textCollapsed = "zwiń szczegóły",
  onButtonPress,
}: ArrowButtonProps) {
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const { buttonProps } = useButton(
    {
      onPress: onButtonPress,
    },
    buttonRef,
  );

  return (
    <button
      className="bg-transparent border-none cursor-pointer flex items-center from-tablet:mt-0"
      ref={buttonRef}
      {...buttonProps}
    >
      <BlockText
        align={{
          "@onlyMobile": "left",
          "@fromTablet": "right",
        }}
        className="whitespace-nowrap"
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "s",
        }}
        weight="bold"
      >
        {isExpanded ? textCollapsed : textExpanded}
      </BlockText>
      <Icon
        className="ml-[12px] flex-shrink-0 w-[16px] h-[16px] from-tablet:ml-3"
        height={16}
        name={isExpanded ? "chevron-up" : "chevron-down"}
        tone="neutral"
        width={16}
      />
    </button>
  );
}
